import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { Layout } from "antd";
import {
  checkIsAdmin,
  getLocalStorage,
  getValidLandingScreen,
  isPreAssessmentComplete,
} from "../../helpers/utils";
import Header from "../../components/Header";
import { AppShell } from "../../components/shell";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const Authmiddleware = ({ component: Component, isAuthProtected, ...rest }) => {
  const { Content } = Layout;
  const location = useLocation();
  const history = useHistory();

  const auth = getLocalStorage("AUTH_DETAILS");
  const userData = getLocalStorage("USER_DETAILS");

  useEffect(() => {
    if (!isAuthProtected) {
      const handleStorageChange = (event) => {
        if (
          event.storageArea === localStorage &&
          event.key === "USER_DETAILS" &&
          event.newValue
        ) {
          history.push(getValidLandingScreen());
        }
      };

      window.addEventListener("storage", handleStorageChange);
      return () => window.removeEventListener("storage", handleStorageChange);
    }
  }, [isAuthProtected]);

  // Not every authenticated route uses the shared AppShell:
  //   - /pre-assessments: a focused onboarding gate that keeps the legacy full-width
  //     header (no app nav while the user is redirected here).
  //   - /survey and /admin-survey-questionnaire: the assessment questionnaire renders
  //     fully focused — no app chrome at all (no shell sidebar, no header). The
  //     questionnaire provides its own domain rail + SurveyHeader/back control.
  const legacyHeaderRoutes = ["/pre-assessments"];
  const isLegacyHeaderScreen = legacyHeaderRoutes.includes(location.pathname);
  const standaloneRoutes = ["/survey", "/admin-survey-questionnaire"];
  const isStandaloneScreen = standaloneRoutes.includes(location.pathname);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthProtected) {
          if (!userData || !auth) {
            return <Redirect to="/sign-in" />;
          } else if (
            !isPreAssessmentComplete() &&
            checkIsAdmin() &&
            location.pathname !== "/pre-assessments"
          ) {
            return <Redirect to="/pre-assessments" />;
          }
        }

        // Auth pages (sign-in, sign-up, magic link, reset…) render standalone.
        if (!isAuthProtected) {
          return <Component {...props} />;
        }

        // Assessment questionnaire: fully focused — no app chrome (no shell sidebar
        // or header). The questionnaire renders its own domain rail + SurveyHeader.
        if (isStandaloneScreen) {
          return <Component {...props} />;
        }

        // Legacy-header route (pre-assessment gate): preserve the legacy header +
        // full-width wrapper.
        if (isLegacyHeaderScreen) {
          return (
            <Layout style={{ minHeight: "100vh" }}>
              <Layout className="site-layout">
                {userData && <Header />}
                <Content>
                  <div
                    className="components-wrapper"
                    style={{ paddingTop: userData ? 72 : "" }}
                  >
                    <Component {...props} />
                  </div>
                </Content>
              </Layout>
            </Layout>
          );
        }

        // All other authenticated routes render inside the shared shell.
        return (
          <AppShell>
            <Component {...props} />
          </AppShell>
        );
      }}
    />
  );
};

Authmiddleware.propTypes = {
  component: PropTypes.any,
  isAuthProtected: PropTypes.bool,
};

export default Authmiddleware;
